module.exports = __webpack_public_path__ + "media/images/logo-dark-blue-2d6c0e78c4d079b16c6238c804b6af89.svg";